import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { AlertConfigDtoSchema } from '../contracts';

const _GetAlertsSettingsRequestDtoSchema = z.object({ facilityId: z.number() });

const GetAlertsSettingsResponseDtoSchema = z.array(AlertConfigDtoSchema);

export type GetAlertsSettingsRequestDto = z.infer<
  typeof _GetAlertsSettingsRequestDtoSchema
>;
export type GetAlertsSettingsResponseDto = z.infer<
  typeof GetAlertsSettingsResponseDtoSchema
>;

export const getAlertsSettings = (
  params: GetAlertsSettingsRequestDto,
  config?: AxiosRequestConfig
) => {
  const { facilityId } = params;

  return api
    .get(`/facilities/${facilityId}/alert-settings`, config)
    .then(responseContract(GetAlertsSettingsResponseDtoSchema));
};
